import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container max-w-4xl mx-auto py-12 px-4 md:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Privacy Policy</h1>
      <p className="text-lg text-gray-700 mb-8 leading-relaxed">
        At <strong>Cycle Services</strong>, your privacy is very important to us. 
        This Privacy Policy explains how we collect, use, and protect your personal 
        information when you visit our website, place an order, or interact with our bicycle 
        sales, rental, repair, and service offerings.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        We may collect the following personal information when you shop or book services with us:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Full name and contact details (email, phone number, billing/shipping address).</li>
        <li>Payment information (processed securely through trusted payment gateways).</li>
        <li>Order/service history, bicycle models, parts/accessories preferences, and sizes/specifications.</li>
        <li>Feedback, inquiries, maintenance/repair details, and communication with our support team.</li>
        <li>Photos or reviews of cycles/services shared voluntarily for promotions or testimonials.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        Your personal data may be used to:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Process and deliver your cycle orders or service appointments.</li>
        <li>Communicate order updates, shipping details, repair status, and customer support.</li>
        <li>Personalize your shopping experience and recommend bicycle models, parts, or services.</li>
        <li>Send promotional emails about cycle deals, rentals, or maintenance tips (with your consent).</li>
        <li>Improve our website, services, and bicycle/product offerings.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        Cycle Services does <strong>not</strong> sell or rent your personal information. 
        We may share your details only:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>With trusted courier and logistics partners to fulfill your order.</li>
        <li>With secure payment gateways for processing transactions.</li>
        <li>When required by law, regulation, or legal process.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Data Security</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        We use industry-standard security measures to protect your data against unauthorized 
        access, misuse, or disclosure. Sensitive information such as payment details is 
        encrypted and handled by secure providers.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Your Rights</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        You have the right to:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 mb-6 space-y-2">
        <li>Request access, updates, or deletion of your personal data.</li>
        <li>Opt out of marketing or promotional communications at any time.</li>
        <li>Request clarification on how your data is used or stored.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Photos, Reviews & Testimonials</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        If you share photos, reviews, or testimonials (e.g., of cycles, repairs, or rentals) 
        with us, we may use them for promotional purposes on our website or social media 
        (with your consent).
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Cookies</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Our website may use cookies to enhance functionality, improve user experience, 
        and analyze anonymous usage data. You can manage cookie preferences through your 
        browser settings.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Policy Updates</h2>
      <p className="text-lg text-gray-700 mb-6 leading-relaxed">
        Cycle Services may update this Privacy Policy from time to time. Any changes will 
        be posted on this page, and we encourage you to review it periodically.
      </p>

      <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Contact Us</h2>
      <p className="text-lg text-gray-700 mb-4 leading-relaxed">
        If you have any privacy-related concerns, please contact us at:
      </p>
      <ul className="list-disc list-inside text-lg text-gray-700 space-y-2">
        <li><strong>Phone:</strong> 1234567891</li>
        <li><strong>Email:</strong> cyclerental@gmail.com</li>
        <li><strong>Address:</strong> Mumbai, MH - 400101, India</li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
